import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_PROJECT,
} from '@modules/general-settings/submodules/project-settings/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsProjectModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME,
      path: 'company',

      component: () => import('@modules/general-settings/submodules/project-settings/pages/AdminGeneralSettingsProjectPage/AdminGeneralSettingsProjectPage.vue'),
      permission: ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS.PROJECTSETTINGS_EDIT,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_PROJECT, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS.PROJECTSETTINGS_EDIT,
      id: ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_PROJECT, getTranslationKeys);
  }
}
